module.exports = __webpack_public_path__ + "static/media/delete.e9e5654c.svg";